import styled from 'styled-components';

export const BookingDetailContainerStyled = styled.div`

`;
